module.exports = __webpack_public_path__ + "static/media/mobile-banner.a55ea5ae.png";